import { render, staticRenderFns } from "./EmployeeAddress2Field.vue?vue&type=template&id=54d88c02&"
import script from "./EmployeeAddress2Field.vue?vue&type=script&lang=js&"
export * from "./EmployeeAddress2Field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d88c02')) {
      api.createRecord('54d88c02', component.options)
    } else {
      api.reload('54d88c02', component.options)
    }
    module.hot.accept("./EmployeeAddress2Field.vue?vue&type=template&id=54d88c02&", function () {
      api.rerender('54d88c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/fields/EmployeeAddress2Field.vue"
export default component.exports